import { editDistance } from 'utils/editDistance';
import { normalize } from 'utils/stringCompare';

export function dedupeArticlesBySection(articles) {
  if (!Array.isArray(articles)) return [];

  const seenSections = new Set();
  const deduped = [];

  for (let i = 0; i < articles.length; i += 1) {
    const article = articles[i];
    const sectionUid = article?.section?.uid;
    if (sectionUid && !seenSections.has(sectionUid)) {
      seenSections.add(sectionUid);
      deduped.push(article);
    }
  }

  return deduped.sort((a, b) => (a?.section?.ordering || 0) - (b?.section?.ordering || 0));
}

function getEditDistanceThreshold(word) {
  if (word.length <= 2) return 0;
  if (word.length <= 6) return 1;
  return 2;
}

function fuzzyContainsWord(fieldWord, queryWord, threshold) {
  if (threshold === 0) return fieldWord.includes(queryWord);

  const minWindow = Math.max(1, queryWord.length - threshold);
  const maxWindow = Math.min(fieldWord.length, queryWord.length + threshold);

  for (let windowSize = minWindow; windowSize <= maxWindow; windowSize += 1) {
    for (let start = 0; start <= fieldWord.length - windowSize; start += 1) {
      const substring = fieldWord.substr(start, windowSize);
      if (editDistance(queryWord, substring) <= threshold) return true;
    }
  }

  return false;
}

function fieldMatchesQuery(field, queryWords) {
  const fieldWords = normalize(field || '')
    .split(/\s+/)
    .filter(Boolean);

  for (let i = 0; i < queryWords.length; i += 1) {
    const queryWord = queryWords[i];
    const threshold = getEditDistanceThreshold(queryWord);

    let wordHit = false;
    for (let j = 0; j < fieldWords.length; j += 1) {
      if (fuzzyContainsWord(fieldWords[j], queryWord, threshold)) {
        wordHit = true;
        break;
      }
    }

    if (!wordHit) return false;
  }

  return true;
}

function filterByField(articles, getField, queryWords, deadline = Infinity) {
  const matches = [];
  for (let i = 0; i < articles.length; i += 1) {
    if (Date.now() > deadline) break;
    const article = articles[i];
    if (article && fieldMatchesQuery(getField(article), queryWords)) {
      matches.push(article);
    }
  }
  return matches;
}

export function searchArticles(articles, query) {
  if (!Array.isArray(articles)) return [];

  const normalizedQuery = normalize(query || '').trim();
  if (!normalizedQuery) return articles;

  const queryWords = normalizedQuery.split(/\s+/).filter(Boolean);

  const titleMatches = filterByField(articles, article => article.title, queryWords);
  if (titleMatches.length > 0) return titleMatches;

  const categoryMatches = filterByField(articles, article => article.section?.name, queryWords);
  if (categoryMatches.length > 0) return categoryMatches;

  if (normalizedQuery.length > 10) {
    return filterByField(
      articles,
      article => (article?.html || '').replace(/<[^>]*>/g, ' '),
      queryWords,
      Date.now() + 1000,
    );
  }

  return [];
}
